// ink-component
import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { StyledTile } from './styles';
import { SpacingType } from '../../helpers/constants/layoutPropTypes';

export interface TileProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Children of the tile */
  children: ReactNode;
  /** Sets tile height */
  height?: 'content' | 'full';
  /** Style variants. Accent colors should be used in order, starting with
   * accent-1 and moving on to others when necessary */
  variant?: 'default' | 'accent-1' | 'accent-2' | 'accent-3' | 'accent-4';
  /** Controls internal spacing */
  spacing?: SpacingType;
  /** Removes external spacing */
  trim?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/**
 * @purpose Creates structure around content such as tables, lists or key metrics
 * @group Tile
 * @categories layout
 * @aka box, card
 */
export function Tile(props: TileProps) {
  const { style, className, height, trim, children, variant, spacing, ...otherProps } = props;

  return (
    <ThemeProvider theme={currentTheme => ({ ...currentTheme, height, trim, spacing, tileVariant: variant })}>
      <StyledTile data-testid={props['data-testid']} {...otherProps}>
        {children}
      </StyledTile>
    </ThemeProvider>
  );
}

Tile.defaultProps = {
  height: 'content',
  spacing: 'gutter',
  trim: false,
  variant: 'default',
};

Tile.displayName = 'Tile';

export default Tile;
